import { render } from "./NewBookSubmitForm.vue?vue&type=template&id=56930f98&scoped=true"
import script from "./NewBookSubmitForm.vue?vue&type=script&lang=js"
export * from "./NewBookSubmitForm.vue?vue&type=script&lang=js"

import "./NewBookSubmitForm.vue?vue&type=style&index=0&id=56930f98&scoped=true&lang=css"

import exportComponent from "C:\\Users\\s574086\\textbook-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56930f98"]])

export default __exports__